import Vue from 'vue'
import formatName from 'filters/format-name'
import globalConfig from 'init/global.config'
import globalStore from 'init/global-store'
import { logoutUser } from 'services/token-service'
import msg from 'services/msg'
import profileStore, { ProfilePage } from 'components/profile/profile-store'
import Menu from 'objects/menu/menu'
import MenuList, { IMenuListItem } from 'objects/menu/menu-list'

import withRender from './user-toolbar-m1.html'
import './user-toolbar.scss'

interface IToolbarMenuItem extends IMenuListItem {
  name: ProfilePage | 'logout'
}

export default withRender(Vue.extend({
  components: {
    // tslint:disable-next-line
    'tt-profile': () => import(/* webpackChunkName: 'profile' */ 'components/profile/profile'),
    'tt-menu-list': MenuList,
    'tt-menu': Menu
  },
  data () {
    return {
      globalStore,
      state: profileStore.state
    }
  },
  computed: {
    isLoggedIn() {
      return this.globalStore.user.id
    },
    formattedUsername() {
      return formatName(this.globalStore.user)
    },
    menuItems() {
      return [
        // TODO: include when functionality added
        // { name: 'do-more', iconName: 'bell', title: msg('userToolbar.menu.doMore') },
        // { name: 'posts', iconName: 'helpful-off', title: msg('userToolbar.menu.posts') },
        // { name: 'profile', iconName: 'profile', title: msg('userToolbar.menu.profile') },
        // { name: 'settings', iconName: 'settings', title: msg('userToolbar.menu.settings') },
        { name: 'logout', iconName: 'close',
          title: msg('userToolbar.menu.logout', [this.formattedUsername]) }
      ]
    },
    showToolbar() {
      return !globalConfig.ssoEnabled
    }
  },
  methods: {
    menuItemSelected (item: IToolbarMenuItem) {
      if (item.name === 'logout') {
        logoutUser()
      } else {
        this.state.currentProfilePage = item.name
        this.state.dashboardIsOpen = true
      }
    },
    openMyPosts() {
      if (this.isLoggedIn) {
        this.state.currentProfilePage = 'posts'
        this.state.dashboardIsOpen = true
      } else {
        // tslint:disable-next-line
        import(/* webpackChunkName: 'registration-modal' */ 'components/registration/registration-modal-loader').then((registrationModalLoader) => {
          registrationModalLoader.default.load({ registerFor: 'profile' })
        })
      }
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/user-toolbar/user-toolbar.ts